module.exports = __webpack_public_path__ + "static/media/1350_ItemSelection_GiftShop_step3.c65f855d.png";